<div class="item">
    {{item | json}}
</div>
